import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { apiListBranch, apiListGodown, apiListItem } from "../../../api/master";
import { FaExchangeAlt } from "react-icons/fa";
import ImageUploader from "./ImageUploader";

function ItemViews(props) {
  const [gGodown, setGodown] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [itemCatList, setItemCatList] = useState([]);
  const [itemData, setItemData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [currentImageUrl, setCurrentImageUrl] = useState(
    props.id?.img_url || null,
  ); // Existing image

  console.log("itemDataitemDataitemDataitemData", itemData);
  const fetchMasterData = async () => {
    try {
      const [branchRes, godownRes, itemCatRes] = await Promise.all([
        apiListBranch({ paginate: 0 }),
        apiListGodown({ paginate: 0 }),
        apiListItem({ get_categories: true }),
      ]);

      setBranchlist(branchRes.data.data.list || []);
      setGodown(godownRes.data.data.list || []);
      setItemCatList(itemCatRes.data.data.list || []);
    } catch (err) {
      console.error("Master data fetch error:", err);
    }
  };
  const fetchItemData = async () => {
    if (!props.id?.item_id) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await apiListItem({ item_id: props.id.item_id });
      setItemData(response.data.data?.list[0]);
      setCurrentImageUrl(response.data.data?.list[0].img_url);
    } catch (error) {
      console.error("Item API Error:", error);
      setError("Failed to load item data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMasterData();
  }, []);

  useEffect(() => {
    fetchItemData();
  }, [props.id?.item_id]);

  const godownListMap =
    gGodown?.flatMap((el) => ({
      value: el?.godown_id,
      label: el.godown_name,
    })) || [];

  const branchListMap =
    branchlist?.flatMap((el) => ({
      value: el?.branch_id,
      label: el.branch_name,
    })) || [];

  const itemCatListMap =
    itemCatList?.flatMap((el) => ({
      value: el?.item_cat_id,
      label: el.item_cat_name,
    })) || [];

  console.log("branchlistbranchlistbranchlist", branchlist);

  const getGodownName = (godownId) => {
    return godownListMap.find((g) => g.value == godownId)?.label || "";
  };

  const getBranchName = (branchId) => {
    return branchListMap.find((b) => b.value == branchId)?.label || "";
  };

  const getCategoryName = (catId) => {
    return itemCatListMap.find((c) => c.value == catId)?.label || "";
  };

  console.log("godownListMapgodownListMap", godownListMap, branchListMap);
  if (loading) {
    return (
      <>
        <Modal.Header closeButton>
          <h4 style={{ marginLeft: "20rem", height: "4px" }} id="modalhead">
            View Item
          </h4>
        </Modal.Header>
        <div className="container-fluid p-4" id="buyerAdd">
          <div className="row gy-3">
            <div
              className="col-md-12 d-flex justify-content-center align-items-center"
              style={{ height: "300px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span className="ms-2">Loading item details...</span>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error || !itemData) {
    return (
      <>
        <Modal.Header closeButton>
          <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
            View Item
          </h4>
        </Modal.Header>
        <div className="container-fluid p-4" id="buyerAdd">
          <div className="row gy-3">
            <div className="col-md-12 text-center py-5">
              <h5 className="text-danger">{error || "No item data found"}</h5>
              <button
                className="btn btn-outline-primary mt-3"
                onClick={fetchItemData}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "20rem", height: "4px" }} id="modalhead">
          View Item
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <div className="row gy-3">
          <div className="col-md-6">
            <label htmlFor="item_name">Name</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="item_name"
              value={itemData.item_name || ""}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="item_cat_id">Category</label>
            <input
              disabled
              type="text"
              maxLength={50}
              className="form-control"
              id="item_cat_id"
              value={
                getCategoryName(itemData.item_cat_id) ||
                itemData.item_cat_name ||
                ""
              }
            />
          </div>

          <div className="col-md-12">
            <label htmlFor="item_desc">Description</label>
            <textarea
              disabled
              maxLength={2000}
              className="form-control"
              id="item_desc"
              value={itemData.item_desc || ""}
              rows={3}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="item_unit">Base Unit</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="item_unit"
              value={itemData.item_unit || ""}
              disabled
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="alt_unit">Alternate Unit</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="alt_unit"
              value={itemData.alt_unit || ""}
              disabled
            />
          </div>

          <div className="col-md-5">
            <label htmlFor="item_unit_conv">Base Conversion</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="item_unit_conv"
              value={1}
              disabled
            />
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <FaExchangeAlt className="mt-4" />
          </div>
          <div className="col-md-5">
            <label htmlFor="alt_conv">Alternate Conversion</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="alt_conv"
              value={itemData.alt_conv || ""}
              disabled
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="item_min_price">Min Price</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="item_min_price"
              value={itemData.item_min_price || ""}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="item_price">Max Price</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="item_price"
              value={itemData.item_price || ""}
              disabled
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="alt_min_price">Min Alternate Price</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="alt_min_price"
              value={itemData.alt_min_price || ""}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="alt_price">Max Alternate Price</label>
            <input
              type="text"
              maxLength={10}
              className="form-control"
              id="alt_price"
              value={itemData.alt_price || ""}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="barcode">Barcode</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="barcode"
              value={itemData.barcode || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="SKU">SKU</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="SKU"
              value={itemData.SKU || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="category_code">URA Category Code</label>
            <input
              disabled
              type="text"
              maxLength={8}
              className="form-control"
              id="category_code"
              value={itemData.category_code || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="field_1">Field 1</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="field_1"
              value={itemData.field_1 || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="field_2">Field 2</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="field_2"
              value={itemData.field_2 || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="field_3">Field 3</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="field_3"
              value={itemData.field_3 || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="video_url">Video URL</label>
            <input
              disabled
              type="text"
              maxLength={100}
              className="form-control"
              id="video_url"
              value={itemData.video_url || ""}
            />
          </div>

          <div className="col-md-12 mt-4">
            <ImageUploader
              label="Product Image"
              imagePreview={imagePreview}
              setImagePreview={setImagePreview}
              maxSizeMB={5}
              // onImageChange={(file) => setImageFile(file)}
              disabled={true}
              initialImageUrl={currentImageUrl}
            />
          </div>

          {itemData.stock && itemData.stock.length > 0 && (
            <>
              <hr style={{ marginBottom: "0px" }} />
              <p
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  margin: "5px",
                }}
              >
                Opening Stock
              </p>
              <div className="col-md-12 m-0">
                <table className="table table-sm table-borderless w-100">
                  <thead>
                    <tr>
                      <th style={{ fontSize: "12px" }}>Godown</th>
                      <th style={{ fontSize: "12px" }}>Opening Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemData.stock.map((v) => (
                      <tr key={v.godown_id}>
                        <td className="w-50">
                          <input
                            type="text"
                            value={getGodownName(v.godown_id)}
                            // value={v.godown_name}
                            className="form-control"
                            disabled
                          />
                        </td>
                        <td className="w-50">
                          <input
                            type="text"
                            value={v.op_st || 0}
                            className="form-control"
                            disabled
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {itemData.item_godown_data &&
            itemData.item_godown_data.length > 0 && (
              <>
                <hr style={{ marginBottom: "0px" }} />
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    margin: "5px",
                  }}
                >
                  Default Godown
                </p>
                <div className="col-md-12 m-0">
                  <table className="table table-sm table-borderless w-100">
                    <thead>
                      <tr>
                        <th style={{ fontSize: "12px" }}>Branch</th>
                        <th style={{ fontSize: "12px" }}>Godown</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemData.item_godown_data.map((v) => (
                        <tr key={`${v.branch_id}-${v.godown_id}`}>
                          <td className="w-50">
                            <input
                              type="text"
                              value={getBranchName(v.branch_id)}
                              className="form-control"
                              disabled
                            />
                          </td>
                          <td className="w-50">
                            <input
                              type="text"
                              value={getGodownName(v.godown_id)}
                              className="form-control"
                              disabled
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

          <div className="col-12 mt-4">
            <button
              className="branchModalCancel"
              onClick={props.hide}
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                float: "right",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ItemViews;
